import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
/* eslint-disable no-shadow */
import { getCookie, setCookie } from '@/utils/storage';
import { emailLogin, userLogout, registerEmail } from '@/api/modules/login';
import { getInfo } from '@/api/modules/personal';
import { SYSTEM_CONFIG } from '@/config/constants';
import { goToLogin } from '@/utils/index.js';
import router from '@/router/index.js';
const state = {
  username: getCookie('username') || '',
  hasLogin: false,
  // 是否登录
  info: {},
  // 用户信息
  userCode: true,
  // 账号状态,
  useProduct: [],
  // 试用产品列表
  productList: [] // 产品（组件，接口，插件）
};
const mutations = {
  RESET_STATE: state => {
    Object.assign(state, {});
  },
  SET_NAME: (state, username) => {
    state.username = username;
  },
  setHasLogin: (state, hasLogin) => {
    state.hasLogin = hasLogin;
  },
  setUserInfo: (state, info) => {
    state.info = info;
  },
  setUseProduct: (state, useProduct) => {
    state.useProduct = useProduct;
  },
  setUserCode: (state, userCode) => {
    state.userCode = userCode;
  },
  setProductList: (state, productList) => {
    state.productList = productList;
  }
};
const actions = {
  register({
    commit
  }, userInfo) {
    const {
      email,
      code,
      company,
      department,
      name
    } = userInfo;
    return new Promise((resolve, reject) => {
      const params = {
        p: email,
        sc: code,
        cp: company,
        dp: department,
        nn: name,
        cc: SYSTEM_CONFIG.CHANNEL_CODE
      };
      registerEmail(params).then(res => {
        commit('SET_NAME', res.nn);
        setCookie('username', res.nn);
        setCookie('uuid', res.u);
        resolve(res);
      }).catch(error => {
        reject(error);
      });
    });
  },
  async login({
    commit
  }, userInfo) {
    let isSucess = false;
    await emailLogin(userInfo).then(async res => {
      if (res.code === 1) {
        localStorage.setItem('access_token', res.result.access_token);
        await getInfo().then(res => {
          if (res.code === 1) {
            const {
              result
            } = res;
            // console.log(result,'pppp');
            if (result) {
              commit('setUseProduct', result.presentation_permissions);
              commit('setUserInfo', {
                customer_name: result.username
              });
              commit('setHasLogin', true);
              commit('setUserCode', true);
            }
          }
        });
        isSucess = true;
        _message.success('登录成功');
        router.push('/homepage');
      } else {
        isSucess = false;
      }
    });
    return isSucess;
  },
  async logout({
    commit
  }) {
    await userLogout({}).then(res => {
      if (res.code === 1) {
        commit('setHasLogin', false);
        commit('setUserInfo', {});
        commit('setUserCode', true);
        if (window.location.href.indexOf('homepage') !== -1) {
          window.location.reload();
        }
        router.push('/homepage');
        _message.success('已登出');
      } else {
        goToLogin('error', res.msg);
      }
    });
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};